module.exports = __webpack_public_path__ + "static/media/21-5.14b8d2bd.mp3";